import * as React from 'react';
import { space } from '@dozuki/web-js/primitives';
import { Text } from '@chakra-ui/react';
import { useEditorContext } from '../editor_context';
import { useLocalization } from '~/framework';

export const CharacterCount = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();
   // Check that the character count extension is loaded
   if (!editor.storage.characterCount) {
      return null;
   }

   const { minCharacters, maxCharacters } = editor.storage.characterCount;
   if (!minCharacters && !maxCharacters) {
      return null;
   }

   const charCount = editor?.storage.characterCount.characters();
   const tooShort = charCount < minCharacters;
   const tooLong = charCount > maxCharacters;
   const charsLeft = maxCharacters - charCount;

   let charCountText: string = String(charsLeft);

   // Margin moves this to the bottom left corner of the editor div
   let styleProps: Object = {
      color: 'gray.400',
      margin: `-24px 0 0 ${space[2]}`,
      position: 'absolute',
      zIndex: '2',
   };

   if (tooShort) {
      /* Translators: %1 -> number of characters; */
      charCountText = _js('%1 too short', (minCharacters - charCount).toString());
   } else if (tooLong) {
      /* Translators: %1 -> number of characters; */
      charCountText = _js('%1 too long', Math.abs(charsLeft).toString());
   }

   if (tooLong || tooShort) {
      styleProps = { ...styleProps, fontWeight: 'bold', color: 'red.600' };
   }

   return <Text {...styleProps}>{charCountText}</Text>;
};
